/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAreasRouteImport } from './routes/_app/areas'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppCrewsRouteImport } from './routes/_app/crews'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppDeadlinesRouteImport } from './routes/_app/deadlines'
import { Route as AppDispatchRouteImport } from './routes/_app/dispatch'
import { Route as AppForbiddenRouteImport } from './routes/_app/forbidden'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppMapRouteImport } from './routes/_app/map'
import { Route as AppPermitsRouteImport } from './routes/_app/permits'
import { Route as AppPitsRouteImport } from './routes/_app/pits'
import { Route as AppReviewRouteImport } from './routes/_app/review'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppImportsOtwRouteImport } from './routes/_app/imports/otw'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppOrdersOrderIdRouteImport } from './routes/_app/orders/$orderId'
import { Route as AppAdminFormsIndexRouteImport } from './routes/_app/admin/forms/index'
import { Route as AppAdminFormsPreviewRouteImport } from './routes/_app/admin/forms/preview'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAreasRoute = AppAreasRouteImport.update({
  id: '/areas',
  path: '/areas',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppCrewsRoute = AppCrewsRouteImport.update({
  id: '/crews',
  path: '/crews',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDeadlinesRoute = AppDeadlinesRouteImport.update({
  id: '/deadlines',
  path: '/deadlines',
  getParentRoute: () => AppRoute,
} as any)
const AppDispatchRoute = AppDispatchRouteImport.update({
  id: '/dispatch',
  path: '/dispatch',
  getParentRoute: () => AppRoute,
} as any)
const AppForbiddenRoute = AppForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppMapRoute = AppMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppRoute,
} as any)
const AppPermitsRoute = AppPermitsRouteImport.update({
  id: '/permits',
  path: '/permits',
  getParentRoute: () => AppRoute,
} as any)
const AppPitsRoute = AppPitsRouteImport.update({
  id: '/pits',
  path: '/pits',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewRoute = AppReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppImportsOtwRoute = AppImportsOtwRouteImport.update({
  id: '/imports/otw',
  path: '/imports/otw',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminFormsIndexRoute = AppAdminFormsIndexRouteImport.update({
  id: '/admin/forms/',
  path: '/admin/forms/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminFormsPreviewRoute = AppAdminFormsPreviewRouteImport.update({
  id: '/admin/forms/preview',
  path: '/admin/forms/preview',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/areas': typeof AppAreasRoute
  '/calendar': typeof AppCalendarRoute
  '/crews': typeof AppCrewsRoute
  '/dashboard': typeof AppDashboardRoute
  '/deadlines': typeof AppDeadlinesRoute
  '/dispatch': typeof AppDispatchRoute
  '/forbidden': typeof AppForbiddenRoute
  '/inbox': typeof AppInboxRoute
  '/map': typeof AppMapRoute
  '/permits': typeof AppPermitsRoute
  '/pits': typeof AppPitsRoute
  '/review': typeof AppReviewRoute
  '/tasks': typeof AppTasksRoute
  '/users': typeof AppUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/imports/otw': typeof AppImportsOtwRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/admin/forms/preview': typeof AppAdminFormsPreviewRoute
  '/admin/forms/': typeof AppAdminFormsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/areas': typeof AppAreasRoute
  '/calendar': typeof AppCalendarRoute
  '/crews': typeof AppCrewsRoute
  '/dashboard': typeof AppDashboardRoute
  '/deadlines': typeof AppDeadlinesRoute
  '/dispatch': typeof AppDispatchRoute
  '/forbidden': typeof AppForbiddenRoute
  '/inbox': typeof AppInboxRoute
  '/map': typeof AppMapRoute
  '/permits': typeof AppPermitsRoute
  '/pits': typeof AppPitsRoute
  '/review': typeof AppReviewRoute
  '/tasks': typeof AppTasksRoute
  '/users': typeof AppUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AppIndexRoute
  '/imports/otw': typeof AppImportsOtwRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders': typeof AppOrdersIndexRoute
  '/admin/forms/preview': typeof AppAdminFormsPreviewRoute
  '/admin/forms': typeof AppAdminFormsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/areas': typeof AppAreasRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/crews': typeof AppCrewsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/deadlines': typeof AppDeadlinesRoute
  '/_app/dispatch': typeof AppDispatchRoute
  '/_app/forbidden': typeof AppForbiddenRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/map': typeof AppMapRoute
  '/_app/permits': typeof AppPermitsRoute
  '/_app/pits': typeof AppPitsRoute
  '/_app/review': typeof AppReviewRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/users': typeof AppUsersRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/imports/otw': typeof AppImportsOtwRoute
  '/_app/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/admin/forms/preview': typeof AppAdminFormsPreviewRoute
  '/_app/admin/forms/': typeof AppAdminFormsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/areas'
    | '/calendar'
    | '/crews'
    | '/dashboard'
    | '/deadlines'
    | '/dispatch'
    | '/forbidden'
    | '/inbox'
    | '/map'
    | '/permits'
    | '/pits'
    | '/review'
    | '/tasks'
    | '/users'
    | '/auth/callback'
    | '/imports/otw'
    | '/orders/$orderId'
    | '/orders/'
    | '/admin/forms/preview'
    | '/admin/forms/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/areas'
    | '/calendar'
    | '/crews'
    | '/dashboard'
    | '/deadlines'
    | '/dispatch'
    | '/forbidden'
    | '/inbox'
    | '/map'
    | '/permits'
    | '/pits'
    | '/review'
    | '/tasks'
    | '/users'
    | '/auth/callback'
    | '/'
    | '/imports/otw'
    | '/orders/$orderId'
    | '/orders'
    | '/admin/forms/preview'
    | '/admin/forms'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/areas'
    | '/_app/calendar'
    | '/_app/crews'
    | '/_app/dashboard'
    | '/_app/deadlines'
    | '/_app/dispatch'
    | '/_app/forbidden'
    | '/_app/inbox'
    | '/_app/map'
    | '/_app/permits'
    | '/_app/pits'
    | '/_app/review'
    | '/_app/tasks'
    | '/_app/users'
    | '/auth/callback'
    | '/_app/'
    | '/_app/imports/otw'
    | '/_app/orders/$orderId'
    | '/_app/orders/'
    | '/_app/admin/forms/preview'
    | '/_app/admin/forms/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/areas': {
      id: '/_app/areas'
      path: '/areas'
      fullPath: '/areas'
      preLoaderRoute: typeof AppAreasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/crews': {
      id: '/_app/crews'
      path: '/crews'
      fullPath: '/crews'
      preLoaderRoute: typeof AppCrewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deadlines': {
      id: '/_app/deadlines'
      path: '/deadlines'
      fullPath: '/deadlines'
      preLoaderRoute: typeof AppDeadlinesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dispatch': {
      id: '/_app/dispatch'
      path: '/dispatch'
      fullPath: '/dispatch'
      preLoaderRoute: typeof AppDispatchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forbidden': {
      id: '/_app/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof AppForbiddenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/map': {
      id: '/_app/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof AppMapRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/permits': {
      id: '/_app/permits'
      path: '/permits'
      fullPath: '/permits'
      preLoaderRoute: typeof AppPermitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pits': {
      id: '/_app/pits'
      path: '/pits'
      fullPath: '/pits'
      preLoaderRoute: typeof AppPitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/review': {
      id: '/_app/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AppReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/imports/otw': {
      id: '/_app/imports/otw'
      path: '/imports/otw'
      fullPath: '/imports/otw'
      preLoaderRoute: typeof AppImportsOtwRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$orderId': {
      id: '/_app/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/forms/': {
      id: '/_app/admin/forms/'
      path: '/admin/forms'
      fullPath: '/admin/forms/'
      preLoaderRoute: typeof AppAdminFormsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/forms/preview': {
      id: '/_app/admin/forms/preview'
      path: '/admin/forms/preview'
      fullPath: '/admin/forms/preview'
      preLoaderRoute: typeof AppAdminFormsPreviewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAreasRoute: typeof AppAreasRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppCrewsRoute: typeof AppCrewsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDeadlinesRoute: typeof AppDeadlinesRoute
  AppDispatchRoute: typeof AppDispatchRoute
  AppForbiddenRoute: typeof AppForbiddenRoute
  AppInboxRoute: typeof AppInboxRoute
  AppMapRoute: typeof AppMapRoute
  AppPermitsRoute: typeof AppPermitsRoute
  AppPitsRoute: typeof AppPitsRoute
  AppReviewRoute: typeof AppReviewRoute
  AppTasksRoute: typeof AppTasksRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppImportsOtwRoute: typeof AppImportsOtwRoute
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppAdminFormsPreviewRoute: typeof AppAdminFormsPreviewRoute
  AppAdminFormsIndexRoute: typeof AppAdminFormsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAreasRoute: AppAreasRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppCrewsRoute: AppCrewsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDeadlinesRoute: AppDeadlinesRoute,
  AppDispatchRoute: AppDispatchRoute,
  AppForbiddenRoute: AppForbiddenRoute,
  AppInboxRoute: AppInboxRoute,
  AppMapRoute: AppMapRoute,
  AppPermitsRoute: AppPermitsRoute,
  AppPitsRoute: AppPitsRoute,
  AppReviewRoute: AppReviewRoute,
  AppTasksRoute: AppTasksRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppImportsOtwRoute: AppImportsOtwRoute,
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppAdminFormsPreviewRoute: AppAdminFormsPreviewRoute,
  AppAdminFormsIndexRoute: AppAdminFormsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
